import { makeStyles } from '@fluentui/react-components';
import { tokens } from '@bingads-webui-fluent-component/tokens';

/**
 * Bootstrap .alert.alert-info → Fluent V2 gray style.
 * Shared by Account Details and Payment steps.
 */
export const useV2AlertOverrides = makeStyles({
  alertOverrides: {
    '& .alert.alert-info': {
      backgroundColor: `${tokens.colorNeutralBackground3} !important`,
      borderRadius: tokens.borderRadiusMedium,
      fontFamily: tokens.fontFamilyBase,
      fontSize: tokens.fontSizeBase300,
      lineHeight: tokens.lineHeightBase300,
      color: `${tokens.colorNeutralForeground1} !important`,
      borderTopColor: 'transparent !important',
      borderRightColor: 'transparent !important',
      borderBottomColor: 'transparent !important',
      borderLeftColor: 'transparent !important',
    },
    '& .alert.alert-info .alert-image': {
      fontSize: '0 !important',
      width: '20px',
      height: '20px',
      minWidth: '20px',
      display: 'inline-block',
      verticalAlign: 'middle',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '20px 20px',
      marginRight: '8px',
      marginTop: '2px',
      // Filled info circle SVG — Fluent V2 style
      // eslint-disable-next-line quotes
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath d='M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM10 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4A.5.5 0 0 0 10 9z' fill='%23616161'/%3E%3C/svg%3E") !important`,
    },
    '& .alert.alert-info .alert-image::before': {
      content: '"" !important',
      fontSize: '0 !important',
    },
  },
});
